import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import store from './app/store/store';
import { loadUser } from "./app/store/actions/authActions";
import 'bootstrap/dist/css/bootstrap.css';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import Buffer from 'buffer';
import './i18n';
store.dispatch(loadUser());

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
